import { defineComponent as s, useCssModule as m, createElementBlock as n, openBlock as o, normalizeClass as l, unref as u, renderSlot as a } from "vue";
import { _ as r } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const c = /* @__PURE__ */ s({
  __name: "MenuItem",
  setup(p) {
    const e = m();
    return (t, d) => (o(), n("li", {
      "data-test": "stash-menu-item",
      role: "menuitem",
      class: l(["stash-menu-item tw-mb-1.5 first:tw-mt-0 last:tw-mb-0", u(e).menuitem])
    }, [
      a(t.$slots, "default")
    ], 2));
  }
}), _ = "_menuitem_1kga5_3", i = {
  menuitem: _
}, f = {
  $style: i
}, k = /* @__PURE__ */ r(c, [["__cssModules", f]]);
export {
  k as default
};
//# sourceMappingURL=MenuItem.js.map
